import React, { memo, forwardRef } from 'react'
import { util } from '../../../util'

const TableCell = (
    { align, size, className, children, layout, isCapitalize = true, ...rest },
    ref
) => {
    return (
        <td
            data-testid={'table-row__cell'}
            className={util.joinClasses(
                'table-row__cell',
                !isCapitalize && 'no-capitalize',
                layout,
                align,
                size,
                className
            )}
            ref={ref}
            {...rest}
        >
            {children}
        </td>
    )
}

export default memo(forwardRef(TableCell))
